import React, { useState } from 'react';
import { Chip, Menu, MenuItem } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { STATUS_META, STATUS_OPTIONS } from '../constants';

const StatusBadge = ({ status, canChange, onChangeStatus }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePick = (nextStatus) => {
    setAnchorEl(null);
    if (nextStatus !== status?.label) onChangeStatus(nextStatus);
  };

  return (
    <>
      <Chip
        size="small"
        label={status?.label || ''}
        onClick={canChange && ![4,5].includes(status?.id) ? (event) => setAnchorEl(event.currentTarget) : undefined}
        onDelete={canChange && ![4,5].includes(status?.id)  ? (event) => setAnchorEl(event.currentTarget) : undefined}
        deleteIcon={canChange && ![4,5].includes(status?.id) ? <ArrowDropDownIcon /> : undefined}
        style={{ backgroundColor: `${STATUS_META[status?.label]?.color}1a`, color: STATUS_META[status?.label]?.color, fontWeight: 600 }}
      />
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {STATUS_OPTIONS.filter((option) => option.label !== status?.label).map((option) => (
          <MenuItem key={option.id} onClick={() => handlePick(option.label)} style={{ color: STATUS_META[option.label].color, fontWeight: 600 }}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default StatusBadge;
